import { Component, OnInit, Output, EventEmitter, Renderer2 } from '@angular/core';
import templateString from './trainingPeriodAccumulationTypeChangeOrder.component.html';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';

@Component({
  standalone: false,
  template: templateString, host: {'forUniqueComponentId': 'asdfafe;alml;wemnelke'}
})
export class TrainingPeriodAccumulationTypeChangeOrderComponent implements OnInit {
    @Output() action = new EventEmitter();
    
    public originalTrainingPeriodAccumulationTypes: any;
    
    public trainingPeriodAccumulationTypes: any;

    constructor(
        private http: HttpClient,
        private bsModalRef: BsModalRef,
        private renderer: Renderer2
    ) { 
        this.renderer.addClass(document.body, 'md-skin');
		this.renderer.addClass(document.body, 'landing-page');
		this.renderer.addClass(document.body, 'fixed-nav');
    }

    ok() {
        this.http.post("training_period_accumulation_types/update_order", { training_period_accumulation_type_ids: this.trainingPeriodAccumulationTypes.map(function(x) { return x.id; }) }).subscribe(() => {
            this.action.emit(true);
            this.bsModalRef.hide();
		});
    }

    cancel() {
        this.bsModalRef.hide();
    };

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.trainingPeriodAccumulationTypes, event.previousIndex, event.currentIndex);
    }

    ngOnInit() {
        this.trainingPeriodAccumulationTypes = JSON.parse(JSON.stringify(this.originalTrainingPeriodAccumulationTypes));
    }
}
